import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { formatAmount, parseAmount, formatDate } from '@Utils/formatters'
import { ERF_CREATE_FAILED_MESSAGE_1, ERF_CREATE_FAILED_MESSAGE_2, EMPTY_STRING, TYPE_OBJECT } from '@Utils/constants'
import { cloneDeep, constant } from 'lodash'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'
import { error } from 'jquery'

export const getListERF = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { hrErfList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateERFList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const fetchApproverDDL = (companyId, moduleID) => (dispatch) => {
    return ApiService.get(`${Path.APPROVERS_DDL}?moduleID=${moduleID}&compID=${companyId}`)
        .then((response) => {
            if (response) {
                return response.data;
            }
        })
}

export const fetchEmployeeSVDropDowns = (compid) => (dispatch) => {
    return ApiService.get(Path.EMPLOYEESV, { compID: compid })
        .then((response) => {
            const data = response.data.map(({ name, value }) => ({ name, value }));
            dispatch(Actions.fetchEmployeeSVDDLValues(data))
            return data;
        })
        .catch((error) => {
            console.log(error);
            return [];
        });
}

export const getRequestName = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.REQUESTOR_NAME, { id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const getDepartmentName = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.DEPARTMENT_NAME, { id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const getProjectLeader = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.PROJECT_LEADER, { id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const getJobTitle = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.JOB_TITLE, { id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

export const getJobLevel = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.JOB_LEVEL, { id })
        .then((response) => {
            let listData = [];
            if (response) {
                const { data } = response;
                listData = data.map(((item) => ({ name: item.name, value: item.value })));
                return listData
            } else {
                listData = data;
            };
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
        });
}

// ERF ADD ACTION OPERATIONS
export const createERF = (erfModel) => (dispatch, getState) => {
    const { hrErfAdd: { alert } } = getState()
    let nAlert = { ...alert }

    dispatch(Actions.showLoading(true))

    return ApiService.post(Path.ROOT, erfModel)
        .then((response) => {
            if (response) {
                let title = 'Create Success'
                let message = 'Successfuly created record.'
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed';
                    message = ERF_CREATE_FAILED_MESSAGE_1;
                    goBackToList = true;
                }

                if (response.data.returnCode == -1) {
                    title = 'Create Failed';
                    message = ERF_CREATE_FAILED_MESSAGE_2;
                    goBackToList = true;
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
                return response.data.returnCode;
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

export const isApproverExist = () => (dispatch, getState) => {
    const { auth } = getState();

    const companyId = auth.credentials.companyId;

    return ApiService.get(`${Path.ISAPPROVEREXIST}?companyID=${companyId}`)
        .then((response) => {
            if (response.status === 200) {
                return response.data === true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
};

// ERF DETAIL/UPDATE ACTION OPERATIONS
export const getERFById = (id) => (dispatch) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
        .then((response) => {
            if (response.status === 200) {
                const { data } = response
                dispatch(Actions.setERFDetail(convertToViewModel(data)))
            } else {
                // TODO: DISPATCH ERROR ALERT FAILED TO LOAD
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const getERLById = (id) => (dispatch) => {
    return ApiService.get(Path.EQUIPMENTREQUESTLIST + '/' + id)
        .then((response) => {
            return response.data.map(({ equipmentID, equipmentName }) => ({ label: equipmentName, value: equipmentID }))
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const getLatestERFID = () => (dispatch, getState) => {
    ApiService.get(Path.LATEST_ERF_ID)
        .then(response => { return response.data })
}

export const resetSearchResults = (companyID, employeeID) => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListERF(companyID, employeeID))
}

// ERF EquipmentRequest ADD ACTION OPERATIONS

export const createEquipmentRequest = (erfModel) => (dispatch, getState) => {
    const { hrErfAdd: { alert } } = getState()
    let nAlert = { ...alert }

    return ApiService.post(Path.EQUIPMENTREQUEST, erfModel)
        .then((response) => {
            if (response) {
                let title = 'Create Success'
                const { message } = response.data
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed'
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

export const deleteERF = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'ERF successfully deleted.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.delete(Path.ROOT + '/' + data)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const updateERF = (detailData) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { hrErfDetail: { detailForm } } = getState()
    const { auth } = getState()

    let updateModel = convertToUpdateModel(detailData);

    if (!isArrayOfIntegers(updateModel.equipmentId)) {
        updateModel.equipmentId = updateModel.equipmentId.map((item) => item.value)
    }

    updateModel.UserId = auth.credentials.userId

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + detailForm.erfID, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                let message = 'Employee Request Form successfully updated.'
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    message = ERF_CREATE_FAILED_MESSAGE_1
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const approveERF = (id, remark, type) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    dispatch(Actions.hasDetailLoaded(false))
    const { auth } = getState()
    let approverModel = {
        UserID: auth.credentials.userId,
        CompID: auth.credentials.companyId,
        ApprovalType: type, // TODO: get constant name STATUS_APPROVED
        Remarks: remark
    }
    return ApiService.put(Path.APPROVAL + '/' + id, approverModel)
        .then((response) => {
            if (response) {
                dispatch(getListERF())
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const approveERFDetail = (id, remark, type) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    dispatch(Actions.hasDetailLoaded(false))
    const { auth } = getState()
    let approverModel = {
        UserID: auth.credentials.userId,
        CompID: auth.credentials.companyId,
        ApprovalType: type, // TODO: get constant name STATUS_APPROVED
        Remarks: remark
    }
    return ApiService.put(Path.APPROVAL + '/' + id, approverModel)
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
            dispatch(Actions.hasDetailLoaded(true))
            window.location.reload()
        })
}

export const changeERFApprover = (id, newApproverID) => (dispatch, getState) => {
    let approverModel = {
        ApproverID: newApproverID
    }
    return ApiService.put(Path.UPDATEAPPROVER + '/' + id, approverModel)
        .then((response) => {
            if (response) {
                dispatch(getListERF())
            }
        })
        .catch((error) => {
            console.error(error)
        })
}

export const cancelERF = (id) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    dispatch(Actions.hasDetailLoaded(false))
    const { auth } = getState()
    let approverModel = {
        UserID: auth.credentials.userId,
        CompID: auth.credentials.companyId,
        ApprovalType: 19, // TODO: get constant name STATUS_CANCELLED
    }

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.APPROVAL + '/' + id, approverModel)
        .then((response) => {
            if (response) {
                let title = 'Cancel Failed'
                let message = 'ERF cancellation error occured.'
                if (response.data != '') {
                    title = 'Cancel Success'
                    message = 'ERF successfully cancelled.'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }

            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const exportERFReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { hrErfList: { searchFilter } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(searchFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId
    updateSortModel.requestDate = moment.utc(updateSortModel.requestDate).format()

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const exportERFSummaryReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { hrErfList: { searchFilter } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(searchFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompID = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId
    updateSortModel.requestDate = moment.utc(updateSortModel.requestDate).format()

    return ApiService.export(Path.SUMMARY_EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const getModuleApproverDDL = (moduleID, companyId) => {
    return ApiService.get(Path.GETMODULEAPPROVERDDL, moduleID, companyId)
        .then((response) => { return response.data })
        .catch((error) => {
            console.error(error)
        })
}
//ERF LIST ACTIONS/ACTION OPERATIONS

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListERF())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListERF())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListERF())
}

export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListERF())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { hrErfList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const getEquipmentTypeName = (isUpdate = false) => async (dispatch, getState) => {
    if (isUpdate) {
        dispatch(Actions.hasDetailLoaded(false));
    } else {
        dispatch(Actions.showLoading(true));
    }
    let data;

     try {
            const response = await ApiService.get(Path.EQUIPMENT_TYPE);
            if (response) {
                data = response.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            if (isUpdate) {
                dispatch(Actions.hasDetailLoaded(true));
            } else {
                dispatch(Actions.showLoading(false));
            }
        }
    
        return data;
}

export const getHolidayDates = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true))
    return ApiService.get(Path.GET_HOLIDAY_DATES, { company })
        .then((response) => {
            let listData = response ? response.data.map(date => moment(date).format("YYYY-MM-DD")) : [];
            dispatch(Actions.setHolidayDates({holidayDates: listData}));
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
}

export const fetchHiredCandidates = (id) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    return ApiService.get(`${Path.GET_HIRED_CANDIDATES}?id=${id}`)
        .then((response) => {
        if (response && response.data) {
            const listData = response.data.map(item => ({
            label: item.name,
            value: item.value,
            }));
            dispatch(Actions.setHiredCandidates({
                data: listData,
                totalCount: listData.length,
            }))
        }
        })
        .finally(() => {
        dispatch(Actions.showLoading(false));
        })
}

export const convertToUpdateModel = (data) => {
    return {
        ...data,
        hireNeededDate: moment.utc(data.hireNeededDate).format(),
        requestDate: moment.utc(data.requestDate).format(),
        dateProcessed: moment.utc(data.dateProcessed).format(),
        equipmentId: (data.EquipmentArrayIDS || []).map(item =>
        typeof item === TYPE_OBJECT ? item.value : item
        ),
        equipmentType: data.equipmentType,
        hiredCandidatesId: (data.HiredCandidates || []).map(item =>
        typeof item === TYPE_OBJECT ? item.value : item
        ),
    }
}

export const convertToViewModel = (data) => {
    return {
        ...data,
        requestDate: formatDate(data.requestDate),
        dateProcessed: formatDate(data.dateProcessed),
        jobPostingStatus: data.jobPostingStatus == null ? EMPTY_STRING : data.jobPostingStatus,
        EquipmentArrayIDS: (data.listOfEquipment || []).map(items => ({
        label: items.equipmentName,
        value: items.equipmentID
        })),
        EquipmentType: data.equipmentType,
        HiredCandidates: (data.listOfHiredCandidates || []).map(items => ({
        label: items.employeeName,
        value: items.employeeID
        })),
    }
}

export function isArrayOfIntegers(array) {
    return array.every(item => Number.isInteger(item));
}


